import { Badge } from '@/components/ui/badge';
import type {
  GoChecklistItemStatus,
  GoChecklistVerdict,
} from '../types/go-checklist.types';

const VERDICT_CONFIG: Record<
  GoChecklistVerdict,
  { label: string; className: string; emoji: string }
> = {
  GO_RECOMMENDED: {
    label: 'GO recommandé',
    className: 'bg-green-100 text-green-800 hover:bg-green-100',
    emoji: '🟢',
  },
  GO_WITH_RESERVES: {
    label: 'GO avec réserves',
    className: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
    emoji: '🟡',
  },
  NO_GO_RECOMMENDED: {
    label: 'NO-GO recommandé',
    className: 'bg-red-100 text-red-800 hover:bg-red-100',
    emoji: '🔴',
  },
  UNDETERMINABLE: {
    label: 'Indéterminable',
    className: 'bg-slate-100 text-slate-800 hover:bg-slate-100',
    emoji: '⚪',
  },
};

const ITEM_STATUS_CONFIG: Record<
  GoChecklistItemStatus,
  { label: string; className: string }
> = {
  CONFORM: { label: 'Conforme', className: 'bg-green-100 text-green-800' },
  WARNING: { label: 'À surveiller', className: 'bg-amber-100 text-amber-800' },
  NON_CONFORM: { label: 'Non conforme', className: 'bg-red-100 text-red-800' },
  UNDETERMINABLE: { label: 'Indéterminable', className: 'bg-slate-100 text-slate-800' },
};

export function VerdictBadge({ verdict, score }: { verdict: GoChecklistVerdict; score?: number }) {
  const cfg = VERDICT_CONFIG[verdict];
  return (
    <Badge className={cfg.className}>
      {cfg.emoji} {cfg.label}
      {score !== undefined && <span className="ml-1 opacity-70">({score}/100)</span>}
    </Badge>
  );
}

export function ItemStatusBadge({
  status,
  isOverridden,
}: {
  status: GoChecklistItemStatus;
  isOverridden?: boolean;
}) {
  const cfg = ITEM_STATUS_CONFIG[status];
  return (
    <Badge className={`${cfg.className} hover:opacity-100`}>
      {cfg.label}
      {isOverridden && <span className="ml-1 text-xs">✎</span>}
    </Badge>
  );
}
